// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/radio-check-readability-scale.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/radio-check-readability-scale/radio-check-readability-scale.js';

mount([g0]);
